// extracted by mini-css-extract-plugin
module.exports = {"gatewayCarouselBlock":"gatewayCarouselBlock_gatewayCarouselBlock__Gc7E6"};